import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Observable, map, of } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthedUserResolver {
  constructor(
    private readonly navCtrl: NavController,
    private readonly authService: AuthService
  ) {}

  resolve(): Observable<boolean> {
    return this.authService.getStoredAuthData().pipe(
      map((authData) => {
        if (authData) {
          this.navCtrl.navigateRoot('store');
          return true;
        }
        return true;
      })
    );
  }
}
